import hex2rgb = PIXI.utils.hex2rgb;
import rgb2hex = PIXI.utils.rgb2hex;

export class ColorOverlayFilter extends PIXI.Filter<any> {

    private static readonly FRAG: string = `
        varying vec2 vTextureCoord;
        uniform sampler2D uSampler;
        uniform vec3 color;
        uniform float mixAmount;
        void main(void) {
            vec4 currentColor = texture2D(uSampler, vTextureCoord);
            vec3 colorOverlay = mix(currentColor.rgb, color * currentColor.a, mixAmount);
            gl_FragColor = vec4(colorOverlay.r, colorOverlay.g, colorOverlay.b, currentColor.a);
        }
    `;

    private _color: number = 0x000000;
    private _mix: number = 1;

    constructor(color: number | [number, number, number] = 0x000000, mix: number = 1) {
        super(undefined, ColorOverlayFilter.FRAG);
        this.uniforms.color = new Float32Array(3);
        this.color = color;
        this.mix = mix;
        this.padding = 0;
    }

    /**
     * The resulting color, as a 3 component RGB e.g. [1.0, 0.5, 1.0]
     * @member {number|Array<number>}
     * @default 0x000000
     */
    set color(value: number | [number, number, number]) {
        const arr = this.uniforms.color;
        if (typeof value === "number") {
            hex2rgb(value, arr);
            this._color = value;
        } else {
            arr[0] = value[0];
            arr[1] = value[1];
            arr[2] = value[2];
            this._color = rgb2hex(arr);
        }
    }

    get color(): number | [number, number, number] {
        return this._color;
    }

    get mix(): number {
        return this._mix;
    }

    set mix(value: number) {
        this._mix = value;
        this.uniforms.mixAmount = value;
    }
}
